module.exports = __webpack_public_path__ + "static/img/login-pd.8634e0d5.8634e0d5.png";